import React from 'react';
import Icon from './Icon';
import { useTheme } from '../../context/ThemeContext';

/**
 * Small frosted light/dark switch. Shows a moon in light mode (tap → dark)
 * and a sun in dark mode (tap → light). Reskins with the active theme.
 */
const ThemeToggle = ({ size = 34, style }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      style={{
        width: size,
        height: size,
        flex: `0 0 ${size}px`,
        display: 'inline-grid',
        placeItems: 'center',
        borderRadius: 10,
        background: 'var(--surface-2)',
        WebkitBackdropFilter: 'blur(var(--blur-2)) saturate(140%)',
        backdropFilter: 'blur(var(--blur-2)) saturate(140%)',
        border: '1px solid var(--line)',
        color: 'var(--accent)',
        cursor: 'pointer',
        transition: 'background 120ms var(--ease-out), border-color 120ms, color 120ms',
        ...style,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'var(--accent-soft)';
        e.currentTarget.style.borderColor = 'var(--accent-soft-2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'var(--surface-2)';
        e.currentTarget.style.borderColor = 'var(--line)';
      }}
    >
      <Icon name={isDark ? 'sun' : 'moon'} size={Math.round(size * 0.5)} strokeWidth={2} />
    </button>
  );
};

export default ThemeToggle;
